import { createActions } from 'redux-actions';

export const documentFieldsActions = createActions({
  FETCH_FIELDS: workerOptions => workerOptions,
  FETCH_FIELDS_SUCCESS: fields => fields,
  FETCH_FIELDS_FAIL: [error => error, (...[, processedError]) => processedError],
  RESET_FIELDS: () => [],
}, { prefix: 'MT_DOCUMENT_FIELDS' });
